import { createTheme } from "@mui/material/styles";
import { gray, orange, purple, white } from "./colors";

const theme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: purple[900], // Full bg
      paper: purple[800], // Cards
    },
    primary: {
      main: orange[500], // Accent color
      light: orange[300],
      dark: orange[700],
    },
    secondary: {
      main: purple[400],
      dark: purple[600],
    },
    text: {
      primary: white,
      secondary: gray[300],
    },
  },
  typography: {
    fontFamily: `'Poppins', 'Roboto', 'sans-serif'`,
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 500 },
    body1: { fontWeight: 400 },
    button: { textTransform: "none", fontWeight: 500 },
  },
});

export default theme;
